<template>
    <div class="loginContent">
        <div class="loginMask"></div>
        <div class="loginPopup">
            <div class="loginTitle">短信登录</div>
            <div class="loginIcon"></div>
            <div class="loginFlex spb">
                <div class="area">+86</div>
                <el-input placeholder="请输入手机号" v-model="phone" maxlength="11" class="phoneIpt"></el-input>
            </div>
            <div class="verificationBox">
                <el-input placeholder="请输入验证码" v-model="code" class="codeIpt"></el-input>
                <div class="codeBtn" :style="{color: gain ? '#5BA7F5' : '#c6c6c6',cursor: gain ? 'pointer' : 'default'}" @click="codeBtnTap">{{ time == '0' ? '获取验证码' : time + 's后重新获取' }}</div>
            </div>
            <div class="loginBtn" :style="{background: (phone.length == '11' && code != '') ? '#FF6A00' : '#D5D6D9',cursor: (phone.length == '11' && code != '') ? 'pointer' : 'default'}" @click="loginBtnTap">登录</div>
            <div class="loginTips">登录即表示同意{{ webName }} <span>服务协议</span> 与 <span>隐私条款</span></div>
        </div>
    </div>
</template>
<script>
    export default{
        data(){
            return{
                phone: '',
                code: '',
                gain: true,
                time: 0,
                webName: ''
            }
        },
        mounted(){
            this.getIndexCategory()
        },
        methods: {
             // 获取网站名称
             getIndexCategory(){
                this.request.get("index/index/category",{
                    params:{
                       
                    }
                })
                .then(res=>{
                    this.webName = res.data.name
                })
            },
            // 获取验证码
            codeBtnTap(){
                var that = this
                if(that.gain){
                    let tel = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
                    if(!tel.test(this.phone)){
                        this.$message.error('手机号格式有误');
                    }else{
                        this.request.get("api/common/sendSms",{
                            params:{
                                mobile: this.phone,
                                timeStamp: parseInt(new Date().getTime() / 1000)
                            }
                        })
                        .then(res=>{
                            if(res.code){
                                that.time = 60
                                that.gain = false
                                var count = setInterval(function(){
                                    that.time--
                                    if(that.time == 0){
                                        that.gain = true
                                        clearInterval(count)
                                    }
                                },1000)
                            }else{
                                this.$message.error(res.msg);
                            }
                            
                        })
                    }
                }
            },
            // 登录
            loginBtnTap(){
                if(this.phone.length == '11' && this.code != ''){
                    let tel = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
                    if(!tel.test(this.phone)){
                        this.$message.error('手机号格式有误');
                    }else{
                        this.request.get("index/user/login",{
                            params:{
                                mobile: this.phone,
                                code: this.code
                            }
                        })
                        .then(res=>{
                            if(res.code){
                                localStorage.setItem('userInfo',JSON.stringify(res.data))
                                this.$message({
                                    message: '登录成功',
                                    type: 'success'
                                });
                                setTimeout(()=>{
                                    this.$router.go(-1)
                                },1000)
                            }else{
                                this.$message.error(res.msg);
                            }
                        })
                    }
                }
            }
        }
    }
</script>
<style lang="less" scoped>
    .loginContent{
        .loginMask{
            width: 100vw;
            height: 100vh;
            position: fixed;
            left: 0;
            top: 0;
            background: url(../../assets/image/loginBg.png) no-repeat center/cover;
            z-index: 2000;
        }
        .loginPopup{
            width: 400px;
            height: 382px;
            background: #FFFFFF;
            border-radius: 16px;
            position: fixed;
            left: 50vw;
            top: 50vh;
            z-index: 2001;
            margin: -191px 0 0 -200px;
            display: flex;
            flex-direction: column;
            align-items: center;
            .loginTitle{
                font: 18px/18px "Microsoft YaHei";
                color: #282828;
                padding-top: 40px;
            }
            .loginIcon{
                width: 29px;
                height: 3px;
                background: #FF6A00;
                border-radius: 1px;
                margin-top: 7px;
            }
            .loginFlex{
                width: 336px;
                margin-top: 38px;
                .area{
                    width: 54px;
                    height: 40px;
                    background: #EEEFF2;
                    border-radius: 5px;
                    font: 12px/40px "Microsoft YaHei";
                    color: #A0A1A3;
                    text-align: center;
                }
                .phoneIpt{
                    width: 274px;
                    height: 40px;
                    border-radius: 5px;
                }
            }
            .verificationBox{
                width: 336px;
                background: #EEEFF2;
                border-radius: 5px;
                margin-top: 17px;
                position: relative;
                overflow: hidden;
                .codeIpt{
                    width: 336px;
                    height: 40px;
                    background: #EEEFF2;
                    /deep/.el-input {
                        height: 40px;
                    }
                    /deep/.el-input__inner {
                        height: 40px;
                        background: #EEEFF2;
                    }
                }
                .codeBtn{
                    height: 40px;
                    padding: 0 12px;
                    font: 14px/40px "Microsoft YaHei";
                    position: absolute;
                    top: 0;
                    right: 0;
                }
            }
            .loginBtn{
                width: 336px;
                height: 40px;
                border-radius: 4px;
                margin-top: 47px;
                font: 14px/40px "Microsoft YaHei";
                color: #fff;
                text-align: center;
            }
            .loginTips{
                font: 13px/13px "Microsoft YaHei";
                color: #4F4F4F;
                margin-top: 34px;
                span{
                    color: #FF6A00;
                    cursor: pointer;
                }
            }
        }
    }
</style>